<template>
  <dispatch-renderer
    :schema="params.control.schema"
    :uischema="params.control.uischema"
    :path="params.control.path"
    :enabled="params.control.enabled"
    :renderers="params.control.renderers"
    :cells="params.control.cells"
  />
</template>

<script lang="ts">
import {
  ControlElement,
  JsonFormsCellRendererRegistryEntry,
  JsonFormsRendererRegistryEntry,
} from '@jsonforms/core';
import { DispatchRenderer } from '@jsonforms/vue2';
import { Schema } from 'ajv';
import { defineComponent } from 'vue';

interface AgDispatchRendererParams {
  control: {
    schema: Schema;
    uischema: ControlElement;
    path: string;
    enabled: boolean;
    renderers: JsonFormsRendererRegistryEntry[];
    cells: JsonFormsCellRendererRegistryEntry[];
  };
}

const agDispatchRenderer = defineComponent({
  name: 'AgDispatchRenderer',
  components: { DispatchRenderer },
  setup() {
    const params: AgDispatchRendererParams | null = null;

    return {
      params: params!,
    };
  },
});

export default agDispatchRenderer;
</script>
